import { Injectable } from '@angular/core';
import {
  TranslocoMissingHandler,
  TranslocoMissingHandlerData,
} from '@ngneat/transloco';
import type { HashMap } from '@ngneat/transloco';
import { environment } from 'environments/environment';

/**
 * Point d’extension officiel Transloco pour les clés absentes (après repli
 * {@link TranslocoConfig.missingHandler.useFallbackTranslation}).
 * Toute traduction manquante passe par ici — ce n’est pas contournable côté pipe/directive.
 */
@Injectable()
export class AppTranslocoMissingHandler implements TranslocoMissingHandler {
  private readonly loggedKeys = new Set<string>();

  handle(key: string, data: TranslocoMissingHandlerData, _params?: HashMap): string {
    const shouldLog = data.missingHandler?.logMissingKey && !data.prodMode;
    if (shouldLog && !this.loggedKeys.has(key)) {
      this.loggedKeys.add(key);
      console.warn(`[i18n] Missing translation (lang=${data.activeLang})`, key);
    }
    if (environment.production) {
      return key;
    }
    return `[i18n] ${key}`;
  }
}
